var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_13328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 9.66672H6V15.7605H7.1923L6.2707 16.6821L11.2979 21.7091L12.016 20.9909L13.4523 22.4272L14.6668 21.2128C15.3625 21.9084 15.5942 22.1403 15.7406 22.2865C16.0187 22.0087 16.5928 21.4333 17.1748 20.8551L18.0288 21.7091C18.2708 21.4671 22.8141 16.9238 23.0559 16.6821L22.1344 15.7605H23.3333V9.66672ZM7.70712 16.6821L8.62859 15.7605H9.21006C9.31586 15.8659 9.46199 16.0115 9.63813 16.1873L8.4252 17.4001L7.70712 16.6821ZM9.14341 18.1184L10.3569 16.9049C10.5805 17.1283 10.8224 17.37 11.0753 17.6227L9.86162 18.8364L9.14341 18.1184ZM11.2979 20.2727L10.5797 19.5546L11.7937 18.3407C12.032 18.5787 12.2731 18.8198 12.512 19.0586L11.2979 20.2727ZM13.4523 20.9909L12.7342 20.2727L13.2302 19.7767C13.4819 20.0281 13.7236 20.2698 13.9486 20.4946L13.4523 20.9909ZM18.7416 15.2402L18.0234 15.9584L20.1833 18.1184L19.4651 18.8364L17.3053 16.6765L16.5871 17.3947C16.8504 17.658 18.4706 19.2783 18.747 19.5546L18.0288 20.2727L15.869 18.1128L15.1508 18.831L16.4567 20.1369C16.284 20.3084 16.0803 20.511 15.7406 20.8502C8.91133 14.0216 9.93502 15.051 9.62848 14.7448H7.01562V10.6823H12.1276V15.7605H12.6354C13.9584 15.7605 15.0478 14.7431 15.1638 13.4498C15.4651 13.627 15.8159 13.7292 16.1901 13.7292H18.6667L21.6196 16.6821L20.9014 17.4001C20.619 17.1177 18.9909 15.4895 18.7416 15.2402ZM22.3177 14.7448H21.1188L19.0875 12.7136H16.1901C15.6301 12.7136 15.1745 12.258 15.1745 11.698H14.1589V13.2214C14.1589 13.8834 13.7344 14.4482 13.1432 14.6578V10.6823H22.3177V14.7448Z",
    fill: "#5A6078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1592 5.60421H15.1748V8.65108H14.1592V5.60421Z",
    fill: "#5A6078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 6.26041L19.0883 6.97862L17.0571 9.00987L16.3389 8.29166L18.3701 6.26041Z",
    fill: "#5A6078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9632 6.26057L12.9944 8.29182L12.2764 9.01004L10.2451 6.97879L10.9632 6.26057Z",
    fill: "#5A6078"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33333,
    y: 1.33333,
    width: 25.3333,
    height: 25.3333,
    rx: 12.6667,
    stroke: "#5A6078",
    strokeWidth: 1.33333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_13328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(6 5.33334)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.3a9f4cc5f44f81830620c7e6ae850c51.svg";
export { ForwardRef as ReactComponent };